var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-section"},[_c('div',{staticClass:"tab-pane"},_vm._l((3),function(item){return _c('div',{staticClass:"tab-content loading"})}),0),_c('GridLayoutPlaceholder')],1)}
var staticRenderFns = []

export { render, staticRenderFns }